import PropTypes from 'prop-types'
import { Table, Typography } from 'antd'
import { Link, generatePath } from 'react-router-dom'
import * as ROUTES from 'admin/routes'
import moment from 'moment'

export function ConnectionList({ connections, accountId, projectId }) {
  connections.map(connection => (connection.accountId = accountId))
  connections.map(connection => (connection.projectId = projectId))

  return (
    <Table
      columns={columns}
      dataSource={connections}
      rowKey={row => row.connectionId}
      pagination={false}
      style={{ width: '100%', margin: '3rem 1rem' }}
    />
  )
}

const columns = [
  {
    title: 'Connection Name',
    dataIndex: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    width: '35%'
  },
  {
    title: 'ID',
    dataIndex: 'connectionId',
    sorter: (a, b) => a.connectionId.localeCompare(b.connectionId),
    width: '35%'
  },
  {
    title: 'Creation Date',
    dataIndex: 'createdAt',
    width: '10rem',
    render: createdAt => {
      return (
        <Typography.Text>
          {moment(createdAt).local().format('DD/MM/YYYY HH:mm')}
        </Typography.Text>
      )
    }
  },
  {
    title: 'Edit',
    key: 'edit',
    width: '5rem',
    render: connections => (
      <Typography.Text>
        <Link
          to={generatePath(ROUTES.CONNECTIONS.EDIT, {
            accountId: connections.accountId,
            projectId: connections.projectId,
            connectionId: connections.connectionId
          })}
        >
          Edit
        </Link>
      </Typography.Text>
    )
  }
]

ConnectionList.propTypes = {
  connections: PropTypes.arrayOf(PropTypes.object),
  projectId: PropTypes.string.isRequired,
  accountId: PropTypes.string.isRequired
}
